export default {
  recommended: 'Empfohlen',
};
